const initAccordions = (elements) => {
    elements.forEach(el => {
        const trigger = el.querySelector('.js-accordion-trigger');
        const content = el.querySelector('.js-accordion-content');
        
        const setAccordionHeights = () => {
            if(content) {
                let accordionHeight = content.offsetHeight;
                content.parentNode.style.setProperty('--accordionHeight', `${accordionHeight}px`);
            }
        }

        trigger.addEventListener('click', () => {
            el.classList.toggle('is-active');
        })

        window.addEventListener('DOMContentLoaded', () => {
            setAccordionHeights();
        })

        window.addEventListener('resize', () => {
            setAccordionHeights();
        })
    })
}

export default initAccordions;